var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.video_popup_class,on:{"click":_vm.click_close_popup}},[_c('div',{staticClass:"popup_video_container relative"},[_c('div',{staticClass:"option-bar",on:{"click":_vm.click_close_popup}},[_c('span',{staticClass:"close-link"},[_vm._v("X")])]),_vm._v(" "),_c('img',{attrs:{"src":"static/content/instructions-popup.jpg"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01824a28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/InstructionsPopup.vue
// module id = null
// module chunks = 